// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"6d16c371","454":"af9355e8","520":"6f3b8d08","553":"cf05216b","653":"916f620b","854":"55f8aca2","858":"5958c7a9"}[chunkId] + ".chunk.js";
};